import * as React from "react";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";
import { Link } from "react-router-dom";

import Dropper from "../Dropper/Dropper";

import { useConnectedUser } from "../../Context/ConnectedUserContext";

import { initialLetterUser } from "../../Functions/strings";

const Profile = () => {
  const [toggleDropdown, setToggleDropdown] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);

  const { user, logout } = useConnectedUser();

  const handleToggleAccount = () => {
    setToggleDropdown((prev) => !prev);
  };

  return (
    <Dropper
      className="box-account"
      buttonProps={{
        view: "clear",
        variant: "dark",
        isFullyRounded: true,
        isIconButton: true,
        size: "lg",
      }}
      buttonLabel={
        <div className="header-account">
          <span className="name-account">
            {user?.name &&
              user?.company_name &&
              initialLetterUser(user?.name, user?.company_name)}
          </span>
          <span className="icon-dropdown">
            {!toggleDropdown ? <RiArrowDownSLine /> : <RiArrowUpSLine />}
          </span>
        </div>
      }
      isOpen={isOpen}
      onClick={setIsOpen}
    >
      <div className="content-dropdown">
        {user?.name && <div className="account-title">{user?.name}</div>}
        {user?.company_name && (
          <div className="account-title">{user?.company_name}</div>
        )}

        <div className="wrap-links-dropdown">
          <Link
            to="/edit-account"
            className="link-account"
            onClick={handleToggleAccount}
          >
            Modifier mon compte
          </Link>

          <Link className="link-account" onClick={logout}>
            Se déconnecter
          </Link>
        </div>
      </div>
    </Dropper>
  );
};

export default Profile;
